<section class="image-text-card-wrapper" [ngClass]="{ 'apply-max-width': enableCarouselIndicators }">
  <h2>{{ headline }}</h2>
  <div class="image-text-card-wrapper_services-grid">
    <div class="image-text-card-wrapper_service-card "
         [ngClass]="{ 'add-shadow': applyShadow }"
         [style]="'background-color:' + backgroundColor"
         *ngFor="let service of visibleServices"
    >
      <img src="{{ service.icon }}" alt=""/>
      <h3>{{ service.title | translate }}</h3>
      <p>{{ service.description | translate }}</p>

      <a [routerLink]="learnMoreHref">
        {{ learnMore }}
      </a>
    </div>
  </div>

  <!-- carousel "..." control dots == windows -->
  @if (enableCarouselIndicators && hasMoreItems && isDesktop) {
    <div class="image-text-card-wrapper_carousel-more">
      <button
        type="button"
        *ngFor="let _ of [].constructor(dotCount); let i = index"
        (click)="goToIndex(i)"
        [class.active]="i === currentIndex"
        [attr.aria-label]="'Go to group ' + (i + 1)"
      >
        &bull;
      </button>
    </div>
  }


  @if (buttonName && buttonHref) {
    <div class="image-text-card-wrapper_our-services-btn-w">
      <app-button
        [label]="buttonName"
        [href]="buttonHref"
      />
    </div>
  }
</section>
